import { render } from "./StudentRenderer.vue?vue&type=template&id=361c3da6&ts=true"
import script from "./StudentRenderer.vue?vue&type=script&lang=ts"
export * from "./StudentRenderer.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__